import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default function Divider({
    color = 'gray',
    className,
    ...rest
}) {
    return (
        <div
            data-component="Divider"
            className={cx('sarsa-divider', color, className)}
            {...rest} />
    );
}


Divider.propTypes = {
    /** Makes the divider the specified color */
    color: PropTypes.oneOf(['gray', 'blue', 'yellow', 'red', 'green']),

    /** Additional className added to container */
    className: PropTypes.string
};
